export default function (lotes, pagamentos) {
  let window = 'reciboComitente'
  !this.$uloc.printView.get(window) && this.$uloc.printView.new({
    wid: window,
    title: 'Recibo de Comissão de Lote',
    windowClass: 'erp-print',
    contentClass: '',
    props: {
      lotes: lotes,
      pagamentos: pagamentos
    }
  }, () => import('@/components/pda/print/views/ReciboComitente'))
    .then((wid) => {
    }) // return wid
}
